export default "__VITE_ASSET__9c730546__"